<template>
    <Baseline>
      <template #content>
        <v-row align="center" justify="center">
          <v-col cols="12" class="d-flex justify-center">
            <v-progress-circular
                :size="200"
                :width="8"
                color="primary"
                indeterminate
            ></v-progress-circular>
          </v-col>
        </v-row>
      </template>
    </Baseline>
  </template>
  
  <script>
  import Baseline from '@/components/baseline'
  
  export default{
    components:{
      Baseline,
    }
  }
  </script>